// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"160df6b6","455":"c66af90f","977":"518a48bb"}[chunkId] + ".chunk.js";
};